import React from 'react';

import QualificationDetails from './QualificationDetails.jsx';

var ListItemDetails = React.createClass({

    getInitialState: function() {
        return({
            data : []
        })
    },
    
    render: function(){

        var component = this;

        console.log(this.props);

        const qualifications = this.props.subjects.map( ( qualification ) => {

            return (

                <QualificationDetails
                    qualification = { qualification.qualification }
                    items = { qualification.subjects }
                    filteredText = { component.props.filteredText }
                />

            )

        });

        return (
            <div className="list--item--details" ref="container">
                { qualifications }
            </div>
        );

    }

});

export default ListItemDetails;


/** WEBPACK FOOTER **
 ** ./app/ListItemDetails.jsx
 **/